var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import APIIN from '@/utils/APIIN';
import { UPDATE_CHANNEL_DATA_REQUEST, updateChannelDataFailure, updateChannelDataSuccess } from '@/redux/actions';
const onUpdateChannelData = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.put(`company/channel`, action.payload)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* updateChannelDataWorker(action) {
    try {
        const data = yield call(onUpdateChannelData, action);
        yield put(updateChannelDataSuccess(data));
    }
    catch (error) {
        yield put(updateChannelDataFailure(error));
    }
}
export function* watchUpdateChannelData() {
    yield takeLatest(UPDATE_CHANNEL_DATA_REQUEST, updateChannelDataWorker);
}
